module.exports = __webpack_public_path__ + "img/news_02.75a21e64.jpg";